import {Text} from 'src/design/atoms/Text';
import React from 'react';

export interface FormViewLabelProps {
  children?: React.ReactNode;
}
export const FormViewLabel: React.FC<FormViewLabelProps> = ({children}) => {
  return (
    <Text fw={500} size="sm" c="dimmed">
      {children}
    </Text>
  );
};
